<div class="loading-bar-wrapper">
    <div class="loading-bar-content" [style.width]="percent+'%'"></div>
</div>
